exports.en = {
  REICO_NEWSLETTER: {
    EMAIL: {
      REQUIRED: 'Enter an email',
      PATTERN: 'Enter a valid email'
    },
    REGISTER_BUTTON: 'Subscribe',
    CONFIRMATION: '✔ You have been successfully subscribed. Please, confirm your registration by clicking on a link we sent you by e-mail. Thank you.'
  }
}
